export const dataDigitalBestSeller = [
    {
      id: 1,
      rating:4.8,
      title: 'Capsicum - Green (Loose)',
      priceWithQunt: '500 g',
      price:46.25,
      amount:1,
      category: 'FormFit High Impact Ivy Sports Bra',
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/10000069_20-fresho-capsicum-green.jpg',
    },
    {
      id: 2,
      rating:4,
      title: 'Coriander Leaves',
      priceWithQunt: '100 g',
      price:10.35,
      amount:1,
      category: 'Vitals Running T-Shirt',
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/10000097_19-fresho-coriander-leaves.jpg',
    },
    {
      id: 3,
      rating:4.5,
      title: 'Cucumber (Loose)',
      priceWithQunt: '1 kg',
      price:19.50,
      amount:1,
      category: 'FormFit High Impact Ivy Sports Bra',
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/10000102_17-fresho-cucumber.jpg',
    },
    {
      id: 4,
      rating:3.9,
      title: 'Ladies Fingers (Loose)',
      priceWithQunt: '500 g',
      price:27.50,
      amount:1,
      category: 'Seamless Omber Tights',
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/10000144_13-fresho-ladies-finger.jpg',
    },
    {
      id: 5,
      rating:4,
      title: 'Onion (Loose)',
      priceWithQunt: '1kg',
      price:44.00,
      amount:1,
      category: 'Halftone Print Sport Bra',
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/10000148_30-fresho-onion.jpg',
    },
    {
      id: 6,
      rating:4.2,
      title: 'Tomato - Hybrid (Loose)',
      priceWithQunt: '1 kg',
      price :22.50,
      amount:1,
      category: 'LAYR Solid Sweatshirt',
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/10000200_17-fresho-tomato-hybrid.jpg',
    },
    {
      id: 7,
      rating:4.6,
      title: 'Potato (Loose)',
      priceWithQunt: '1 kg',
      price:47.00,
      amount:1,
      category: 'Flexoft Men`s Slim Lounge Joggers',
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/40048457_9-fresho-potato-new-crop.jpg',
    },
    {
      id: 8,
      rating:3.9,
      title: 'Beans - Haricot (Loose)',
      priceWithQunt: '500 g',
      price:30.25,
      amount:1,
      category: 'Neon Highlight Joggers',
      
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/40089742_2-fresho-beans-haricot.jpg',
    },
    {
      id: 9,
      rating:4,
      title: 'Pure Ghee/Tuppa',
      priceWithQunt: '1 L Pouch',
      price:610.00,
      amount:1,
      category: 'Neon Highlight Joggers',
      
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/213273_7-nandini-pure-ghee.jpg',
    },
    {
      id: 10,
      rating:4,
      title: 'Iodized',
      priceWithQunt: '1 kg Pouch',
      price:27.72,
      amount:1,
      category: 'Neon Highlight Joggers',
      
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/241600_5-tata-salt-iodized.jpg',
    },
    {
      id: 11,
      rating:4,
      title: 'Sun Lite - Sunflower Refined Oil',
      priceWithQunt: '1 L Pouch',
      price:176.00,
      amount:1,
      category: 'Neon Highlight Joggers',
      
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/274145_14-fortune-sun-lite-sunflower-refined-oil.jpg',
    },
    {
      id: 12,
      rating:4,
      title: 'Cumin/Jeera/Jeerige - Whole',
      priceWithQunt: '200 g Pouch',
      price:78.00,
      amount:1,
      category: 'Neon Highlight Joggers',
      
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/10000486_14-bb-royal-cuminjeera-whole.jpg',
    },
    {
      id: 13,
      rating:4,
      title: 'Sona Masoori Raw Rice/Akki - Super Premium, 12 + Months Old',
      priceWithQunt: '25 g Bag',
      price:1475.00,
      amount:1,
      category: 'Neon Highlight Joggers',
      
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/20005940_11-bb-royal-sona-masoori-rice-raw-rice-super-premium-12-months-old.jpg',
    },
    {
      id: 14,
      rating:4.5,
      title: 'Sugar/Sakkare',
      priceWithQunt: '5 kg',
      price:213.00,
      amount:1,
      category: 'Neon Highlight Joggers',
      
      linkImg:
        'https://www.bigbasket.com/media/uploads/p/s/30005417_8-bb-popular-sugar.jpg',
    },
  ];